import { render, staticRenderFns } from "./divider-quarternary.vue?vue&type=template&id=cac191bc&scoped=true&"
import script from "./divider-quarternary.vue?vue&type=script&lang=js&"
export * from "./divider-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac191bc",
  null
  
)

export default component.exports